<template>
  <div>

    <a-table size="small" :pagination="pagination" :columns="columns" row-key="index" :data-source="team_data" :loading="loading" />

  </div>
</template>
<script>
import { getDevWorkInfoDetail } from '@/api/data/noticeboard';

const columns = [
  {
    title: 'ID',
    dataIndex: 'task_id',
    key: 'task_id',
    width: '10%',
    ellipsis: true
  }, {
    title: '团队名称',
    dataIndex: 'team_name',
    key: 'team_name',
    width: '10%',
    ellipsis: true
  }, {
    title: '任务名称',
    dataIndex: 'task_name',
    key: 'task_name',
    width: '10%',
    ellipsis: true
  }, {
    title: '任务point',
    dataIndex: 'task_point',
    key: 'task_point',
    width: '10%',
    ellipsis: true
  }, {
    title: '姓名',
    dataIndex: 'user_name',
    key: 'user_name',
    width: '10%',
    ellipsis: true
  }, {
    title: '开发完成时间',
    dataIndex: 'complete_time',
    key: 'complete_time',
    width: '10%',
    ellipsis: true
  }
];
export default {
  components: {},
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      activeKey: '1',
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []

    };
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    }
  },
  created() {
    this.getDiagramData();
  },
  methods: {
    getDiagramData() {
      getDevWorkInfoDetail({ ...this.filterForm }).then(res => {
        this.team_data = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
